import { css } from '@emotion/react';
import React from 'react';

import { isPaymentsDisabled } from 'features/accounts/paymentsDisabled';
import Chip from 'shared/components/atoms/Chip/Chip';
import { Box } from 'shared/components/display';

import { ACCOUNT_COPY } from 'shared/config/copy';
import COLORS from 'shared/styles/colors';

const styles = css({ display: 'inline-flex', flex: 'none', alignSelf: 'center', marginLeft: '0.5rem' });

interface Props {
  account?: { paymentsDisabled?: boolean } | null;
  className?: string;
}

// Marks WITHIN-client accounts (payments disabled, creators paid via Wrapbook) so marketers can always tell them apart.
// Spacing lives here rather than in parent styles because the account switcher renders in a dropdown portal.
const WithinAccountChip: React.FC<Props> = ({ account, className }) =>
  isPaymentsDisabled(account) ? (
    <Box as="span" css={styles} className={className}>
      <Chip
        label={ACCOUNT_COPY.CHIP_WITHIN_ACCOUNT}
        color={COLORS.PRIMARY600}
        bgColor={COLORS.PRIMARY50}
        square
        dataCy="within-account-chip"
      />
    </Box>
  ) : null;

export default WithinAccountChip;
